import {observer} from "mobx-react";
import React from "react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {translate} from "@dropDesk/storage/i18n/translate_helper";
import DropDeskIcon from "@dropDesk/storage/icons";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {Button, Container} from "@dropDesk/presentation/components/chat_view/chat_message/load_previous_ticket_button/styled";

const LoadAdjacentTicketButton = observer((
    {
        onClick,
        loading,
        direction = 'up',
    }: {
        onClick: () => void,
        loading: boolean,
        direction?: 'up' | 'down',
    }
) => {
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;
    const isUp = direction === 'up';

    return (
        <Container>
            <Button
                type={'button'}
                onClick={onClick}
                disabled={loading}
                background={colors.onBackground}
                color={colors.text}
                border={colors.border}
                accent={colors.accent}
            >
                <DropDeskIcon
                    icon={isUp ? ICONS_DROPDESK.arrowUp : ICONS_DROPDESK.arrowDown}
                    size={14}
                    color={colors.text}
                />
                {loading
                    ? translate(isUp ? 'chat.loadingPreviousTicket' : 'chat.loadingNextTicket')
                    : translate(isUp ? 'chat.loadPreviousTicket' : 'chat.loadNextTicket')}
            </Button>
        </Container>
    );
});

export default LoadAdjacentTicketButton;
